import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

type ReturnIds = {
  sheetIds: string[];
  sheetInformationIds: string[];
  cardIds: string[];
  cardAttributeIds: string[];
  cardShapeIds: string[];
  memoContentIds: string[];
  uiCardItemIds: string[];
  drawContentIds: string[];
  arrowIds: string[];
  sheetTreeIds: string[];
}
const useChildrenTreeIds = (parentId: string | undefined) : ReturnIds => {
  const sheetInformationDb = useSelector((state: RootState) => state.sheetInformationDb);
  const sheetTreeDb = useSelector((state: RootState) => state.sheetTreeDb);
  const cardDb = useSelector((state: RootState) => state.cardDb);
  const cardAttributeDb = useSelector((state: RootState) => state.cardAttributeDb);
  const cardShapeDb = useSelector((state: RootState) => state.cardShapeDb);
  const memoCardContentDb = useSelector((state: RootState) => state.memoCardContentDb);
  const uiCardItemDb = useSelector((state: RootState) => state.uiCardItemDb);
  const drawCardContentDb = useSelector((state: RootState) => state.drawCardContentDb);
  const arrowDb = useSelector((state: RootState) => state.arrowDb);

  const sheetIds: string[] = [];
  const sheetInformationIds: string[] = [];
  const cardIds: string[] = [];
  const cardAttributeIds: string[] = [];
  const cardShapeIds: string[] = [];
  const memoContentIds: string[] = [];
  const uiCardItemIds: string[] = [];
  const drawContentIds: string[] = [];
  const arrowIds: string[] = [];
  const sheetTreeIds: string[] = [];

  const getIdsFromCardIds = (ids: string[], db: {[key in string]: {cardId: string}}): string[] => {
    let nominateIds: string[] = [];
    ids.forEach(id => {
      const targetIds = Object.keys(db).filter(targetId => db[targetId].cardId === id);
      nominateIds.push(...targetIds);
    })
    return nominateIds;
  }
  const getIds = (targetId: string | undefined) : void => {
    // get children sheet tree ids
    const nominateSheetTreeIds = Object.keys(sheetTreeDb.sheetTrees).filter(id => sheetTreeDb.sheetTrees[id].parentSheetId === targetId);
    sheetTreeIds.push(...nominateSheetTreeIds);
    // get children sheet ids
    const nominateSheetIds = nominateSheetTreeIds.map(id => sheetTreeDb.sheetTrees[id].sheetId);
    sheetIds.push(...nominateSheetIds);
    nominateSheetIds.forEach(sheetId => {
      // get children sheet information ids
      const nominateSheetInformationIds = Object.keys(sheetInformationDb.sheetInformations).filter(id => sheetInformationDb.sheetInformations[id].sheetId === sheetId);
      sheetInformationIds.push(...nominateSheetInformationIds);
      // get children card ids
      const nominateCardIds = Object.keys(cardDb.cards).filter(id => cardDb.cards[id].sheetId === sheetId);
      cardIds.push(...nominateCardIds);
      // get children card item ids
      const nominateCardAttributeIds = getIdsFromCardIds(nominateCardIds, cardAttributeDb.cardAttributes);
      cardAttributeIds.push(...nominateCardAttributeIds);
      const nominateCardShapeIds = getIdsFromCardIds(nominateCardIds, cardShapeDb.cardShapes);
      cardShapeIds.push(...nominateCardShapeIds);
      const nominateMemoContentIds = getIdsFromCardIds(nominateCardIds, memoCardContentDb.memoCardContents);
      memoContentIds.push(...nominateMemoContentIds);
      const nominateUiItemIds = getIdsFromCardIds(nominateCardIds, uiCardItemDb.uiCardItems);
      uiCardItemIds.push(...nominateUiItemIds);
      const nominateDrawContentIds = getIdsFromCardIds(nominateCardIds, drawCardContentDb.drawCardContents);
      drawContentIds.push(...nominateDrawContentIds);
      // get children arrow ids
      const nominateArrowIds = Object.keys(arrowDb.arrows).filter(id => arrowDb.arrows[id].sheetId === sheetId);
      arrowIds.push(...nominateArrowIds);
      // check grandchildren existence
      const childrenTrees = Object.keys(sheetTreeDb.sheetTrees).filter(id => sheetTreeDb.sheetTrees[id].parentSheetId === sheetId);
      // if exist, execute recursively
      if (childrenTrees.length > 0) getIds(sheetId);
    })
  }

  getIds(parentId);
  return {sheetIds, sheetInformationIds, cardIds, cardAttributeIds, cardShapeIds, memoContentIds, uiCardItemIds, drawContentIds, arrowIds, sheetTreeIds};
}

export default useChildrenTreeIds;
